export const roundNumber = (num: number, decimals = 1) =>
  Math.round(num * Math.pow(10, decimals) + Number.EPSILON) / Math.pow(10, decimals);
